export default __webpack_public_path__ + "static/media/sidemenu_consultation_history.d163639b.svg";